// removed by extract-text-webpack-plugin
module.exports = {"container":"container-sZRkz container-3-GEX","label":"label-1q3CS label-Y5lvX","required":"required-1CFJs required-3YAAZ","inputContainer":"inputContainer-YRSfE inputContainer-37Qrp","errorMessage":"errorMessage-1v6-q errorMessage-ucFof","input":"input-3Pk7X input-2t6DG","error":"error-2dK-8 inputError-2jP1m","slim":"slim-2fYXS slim-2C1LB","afterInputContainer":"afterInputContainer-3ITG1","short":"short-1cJ0X short-2eEoB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/CharField/_charField.css
// module id = 535
// module chunks = 1